import { Injectable } from '@angular/core';
import { DataApiService } from '../../../services/data-api.service';
import { ToastrServiceLocal } from '../../../services/toast/toastr.service';
import { MensajesHttpService } from '../../../utils/mensajesHttp/mensajes-http.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(    private _dataApi: DataApiService,
    private _toast: ToastrServiceLocal,
    private _mensajesHttp: MensajesHttpService,
    private http: HttpClient,
    private toatr: ToastrService) { }

    obtenerFechaActualEnFormato() {
    const fechaActual = new Date();
    const dia = String(fechaActual.getDate()).padStart(2, "0");
    const mes = String(fechaActual.getMonth() + 1).padStart(2, "0");
    const año = fechaActual.getFullYear();

    return `${dia}-${mes}-${año}`;
  }

    async getLogin(): Promise<any> {
      const obj = {
        user: environment.user,
        pass: environment.pass,
        idSistema: environment.idSistemaFile,
        idOrigen: environment.idOrigen,
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      };

      let url = `${environment.apiUtils}/auth/login/`;

      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          throw new Error("Error en la autenticación");
        }
        return await response.json();

      } catch (err) {
        this._toast.clearToasts();
        this.toatr.error("Ocurrió un error al autenticar");
        throw err; // Propagar el error para que pueda ser manejado en `getImagen`
      }
    }

  async getImagen(params: any, callback:any) {
    try{
      const data = await this.getLogin();
      console.log(2);
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.data[0].table0[0].token,
        },
        body: JSON.stringify(params),
      };
      let url = `${environment.apiUtils}/object/`;
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error("Error al obtener la imagen");
      }
      const result = await response.json();
      callback(result);
    }catch(error){
      console.error(error);
      this.toatr.error("Ocurrió un error al obtener la imagen");
    }
  }


  async postImagen(params: any, callback:any) {
    try{
      const data = await this.getLogin();
      const options = {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + data.data[0].table0[0].token,
        },
        body:params
      };
      let url = `${environment.apiUtils}/object/`;
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error("Error al guardar la imagen");
      }
      const result = await response.json();
      callback(result);
    }catch (error){
      this.toatr.error("Ocurrió un error al Guardar la imagen");
    }
  }


  async deleteImagen(params: any, callback:any) {
    try{
      const data = await this.getLogin();
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.data[0].table0[0].token,
        },
        body: JSON.stringify(params),
      };
      let url = `${environment.apiUtils}/object/delete/`;
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error("Error al eliminar la imagen");
      }
      const result = await response.json();
      callback(result);
    }catch (error){
      this.toatr.error("Ocurrió un error al eliminar la imagen");
    }
  }
}
